export default __webpack_public_path__ + "static/media/guesty_step11.f77c65db.png";